import '../vendor';

import '../general/ofi';
import '../general/search';
import '../general/hamburger';
import '../general/menu';
import '../general/anchor';
import '../general/warning';
import '../general/up';

import '../pages/results/results-search';
import '../pages/results/results-filter';

import '../visually-impaired/open';
import '../visually-impaired/click';
import '../visually-impaired/size';
import '../visually-impaired/color';
import '../visually-impaired/length';
import '../visually-impaired/image';


// WEBPACK FOOTER //
// ./src/js/pages/results.js